// Shared by the existing attachment card and outreach-readiness check.
export function getStudentAttachment(student, slot) {
  if (student.student_document_storage_mode === 'database') {
    const metadata = student.student_documents?.[slot.type];
    return {
      stored: metadata?.status === 'stored',
      pending: metadata?.status === 'pending_migration',
      fileName: metadata?.status === 'stored' ? metadata.file_name : null,
    };
  }
  const filePath = student[slot.field];
  return { stored: !!filePath, pending: false, fileName: filePath ? filePath.split(/[\\/]/).pop() : null };
}

export function getDownloadFileName(disposition, fallback) {
  const utf8 = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8) {
    try { return decodeURIComponent(utf8[1]); } catch { /* use quoted fallback */ }
  }
  return disposition.match(/filename="([^"]*)"/)?.[1] || fallback;
}
